// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M22 18A2 2 0 0 1 20 20H4A2 2 0 0 1 2 18V7.97L2.36 8.27 11.04 15.5A1.5 1.5 0 0 0 12.96 15.5L21.64 8.27 22 7.97ZM20 4A2 2 0 0 1 21.92 5.43L20.36 6.73 12 13.7 3.64 6.73 2.08 5.43A2 2 0 0 1 4 4Z"/>';

/** Email (communication). */
const icon: IconData = {
  id: "email",
  name: "Email",
  category: "communication",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-width="2" d="M3 6.5L11.68 13.73A.5.5 0 0 0 12.32 13.73L21 6.5M4 19H20A1 1 0 0 0 21 18V6A1 1 0 0 0 20 5H4A1 1 0 0 0 3 6V18A1 1 0 0 0 4 19Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M20 4L20.59 4.1 21.27 4.46 21.75 5.05 22 6 21.98 18.2 21.75 18.95 21.27 19.54 20.59 19.9 20 20 3.8 19.98 3.05 19.75 2.46 19.27 2.1 18.59 2 18 2.02 5.8 2.25 5.05 2.73 4.46 3.41 4.1 4 4Z"/></g><path fill="none" stroke="currentColor" stroke-width="2" d="M3 6.5L11.68 13.73A.5.5 0 0 0 12.32 13.73L21 6.5M4 19H20A1 1 0 0 0 21 18V6A1 1 0 0 0 20 5H4A1 1 0 0 0 3 6V18A1 1 0 0 0 4 19Z"/>',
    },
  },
  animation: () => import("../animations/email.js"),
};

export default icon;
